/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_AttemptInputs */



/**
* | output |
* | --- |
* | "Attempt" |
*
* @param {Practice_AttemptInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_attempt = /** @type {((inputs?: Practice_AttemptInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_AttemptInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Poging")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tentative")
	return /** @type {LocalizedString} */ ("Attempt")
});